module.exports = __webpack_public_path__ + "img/product_14.10e3cab.webp";